import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#0A66C1",
      contrastText: "#f8f8f6"
    },
    secondary: {
      main: "#28282b"
    },
    background: {
      default: "#28282b",
      paper: "#25252b"
    },
    text: {
      primary: '#f8f8f6',
      secondary: '#bfbebeff'
    }
  },
  typography: {
    fontFamily: [
      'Montserrat'
    ].join(','),
  }
});

export default darkTheme;